module.exports = __webpack_public_path__ + "static/img/feiji.0c10bc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/feiji.png
// module id = LLvT
// module chunks = 1